import cn from "classnames";
import { useTranslation } from "react-i18next";

import styles from "./ChipGroup.module.scss";

interface ChipOption {
  label: string;
  value: string;
}

interface ChipGroupProps {
  label: string;
  options: ChipOption[];
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

const ChipGroup = ({
  label,
  options,
  value,
  onChange,
  disabled
}: ChipGroupProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.group}>
      <span className={styles.group__label}>{t(label)}</span>

      <div className={styles.group__chips}>
        {options.map((option) => (
          <button
            key={option.value}
            type="button"
            disabled={disabled}
            className={cn(styles.group__chip, {
              [styles.group__chip_active]: option.value === value
            })}
            onClick={() => onChange(option.value)}
          >
            {t(option.label)}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ChipGroup;
